import React from "react";
import { Navigate } from "react-router-dom";

//Invoices
import InvoiceList from "../pages/Invoices/InvoiceList";
import InvoiceCreate from "../pages/Invoices/InvoiceCreate";
import InvoiceDetails from "../pages/Invoices/InvoiceDetails";

// Table Pages
import Projects from "../pages/Tabels/Projects/index";
import Phase from "../pages/Tabels/Phases/index";
import Block from "../pages/Tabels/Block/index";
import Client from "../pages/Client/index";
import Contract from "../pages/Contract/index";
import SettelmentPrice from "../pages/Tabels/SettelmentPrice/index";
import Payment from "../pages/Tabels/Payment/index";
import Units from "../pages/Tabels/Unit/index";
import Users from "../pages/Tabels/Users/index";
import AddUser from "../pages/Tabels/Users/AddUser";
import UserDetails from "../pages/Tabels/Users/UserDetails";
import ClientOverdue from "../pages/Tabels/ClientOverdue/index";

//Login
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import Settings from "../pages/Pages/Profile/Settings/Settings";

//Reporting Pages
import ProjectReporting from "../pages/Reporting/ProjectReporting";

//Details
import SettlementDetails from "../pages/Tabels/SettelmentPrice/SettlementDetails";
import ProjectDetails from "../pages/Tabels/Projects/UnitDetails";
import BlockDetail from "../pages/Tabels/Block/BlockDetail";
import PhaseDetail from "../pages/Tabels/Phases/PhaseDetail";
import UnitDetail from "../pages/Tabels/Unit/UnitDetail";
import ContractDetail from "../pages/Contract/ContractDetail";
import ClientDetail from "../pages/Client/ClientDetail";
import PaymentDetails from "../pages/Tabels/Payment/PaymentDetails";

const authProtectedRoutes = [
  //Tabels
  { path: "/projects", component: <Projects /> },
  { path: "/phases", component: <Phase /> },
  { path: "/blocks", component: <Block /> },
  // { path: "/table-unit", component: <Unit /> },
  { path: "/contracts", component: <Contract /> },
  { path: "/clients/legal", component: <Client /> },
  { path: "/clients/natural", component: <Client /> },
  { path: "/table-client-overdue", component: <ClientOverdue /> },
  { path: "/table-settlement-price", component: <SettelmentPrice /> },
  // { path: "/table-payment", component: <Payment /> },
  { path: "/table-users", component: <Users /> },
  { path: "/table-users/add-user", component: <AddUser /> },
  { path: "/table-users/user-details/:id", component: <UserDetails /> },
  { path: "/units-by-block/:blockId", component: <Units /> },

  //Reporting
  { path: "/project-reporting/:id", component: <ProjectReporting /> },

  //Details Pages
  { path: "/settlement-details/:id", component: <SettlementDetails /> },
  { path: "/project-details/:id", component: <ProjectDetails /> },
  { path: "/block-details/:id", component: <BlockDetail /> },
  { path: "/phase-details/:id", component: <PhaseDetail /> },
  { path: "/unit-details/:id", component: <UnitDetail /> },
  { path: "/contracts/:id", component: <ContractDetail /> },
  { path: "/client-details/:id", component: <ClientDetail /> },
  { path: "/payment-details/:id", component: <PaymentDetails /> },

  //Invoices
  { path: "/apps-invoices-list", component: <InvoiceList /> },
  { path: "/apps-invoices-details", component: <InvoiceDetails /> },
  { path: "/apps-invoices-create", component: <InvoiceCreate /> },

  //Pages
  { path: "/pages-profile-settings", component: <Settings /> },

  {
    path: "/",
    exact: true,
    component: <Navigate to="/contracts" />,
  },
  { path: "*", component: <Navigate to="/contracts" /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
];

export { authProtectedRoutes, publicRoutes };
